import type { RootState } from '~features';
import type { CollectionType } from '~types/CollectionsType';

const selectCollectionConfig = (state: RootState): CollectionType => state.collectionConfig.collection;

export { selectCollectionConfig };
